import {athubAxios} from "@/util";
import {RELATION_SERVER} from "@/api";

const RelationServer = {

    getRelationPageInfo(master, masterKey, searchParams) {
        let url = `${RELATION_SERVER}/relation/${master}/${masterKey}/page`;
        return athubAxios.post(url, searchParams);
    },

    delete(master, masterKey, slave, slaveKey) {
        let url = `${RELATION_SERVER}/relation/${master}/${masterKey}/${slave}/${slaveKey}`;
        return athubAxios.delete(url);
    },

    relation(master, masterKey, slave, params) {
        let url = `${RELATION_SERVER}/relation/${master}/${masterKey}/${slave}`;
        return athubAxios.post(url, params);
    },

    batchRelation(params){
        let url = `${RELATION_SERVER}/relation/batch/related`;
        return athubAxios.post(url, params);
    }
}

export default RelationServer;